import src from "IMAGE";
export default { src, width: 2549, height: 230, blurWidth: 8, blurHeight: 1, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAYAAADjAO9DAAAAH0lEQVR42mNQTX69E4j3APFlID4BxIeB+BEQ3wbiawAb9hH/5J/A+QAAAABJRU5ErkJggg=="};
